/**
 * Accessible keyboard navigation for header mega menu / dropdowns.
 * Layers on top of Prestige's existing MenuDisclosure custom elements.
 *
 * All nav items remain tabbable (natural Tab behavior).
 * Arrow keys are added as supplemental navigation:
 *  - Left/Right arrows move between top-level nav items
 *  - Down arrow opens a submenu and focuses first link
 *  - Up/Down arrows move within a submenu
 *  - Escape closes submenu and returns focus to trigger
 *  - Home/End jump to first/last item in a list
 */
(function () {
  'use strict';

  function init() {
    var nav = document.querySelector('.header__primary-nav');
    if (!nav) return;

    var topItems = Array.from(
      nav.querySelectorAll(':scope > ul > li > a.h6, :scope > ul > li > details > summary')
    );
    if (!topItems.length) return;

    nav.addEventListener('keydown', function (e) {
      var target = e.target;
      var idx = topItems.indexOf(target);

      if (idx > -1) {
        switch (e.key) {
          case 'ArrowRight':
            e.preventDefault();
            topItems[(idx + 1) % topItems.length].focus();
            break;

          case 'ArrowLeft':
            e.preventDefault();
            topItems[(idx - 1 + topItems.length) % topItems.length].focus();
            break;

          case 'ArrowDown':
            var details = target.closest('details');
            if (details) {
              e.preventDefault();
              if (!details.open) {
                details.open = true;
                details.setAttribute('aria-expanded', 'true');
              }
              requestAnimationFrame(function () {
                var firstLink = details.querySelector(
                  '.header__dropdown-menu a, .mega-menu__linklist a'
                );
                if (firstLink) firstLink.focus();
              });
            }
            break;

          case 'Home':
            e.preventDefault();
            topItems[0].focus();
            break;

          case 'End':
            e.preventDefault();
            topItems[topItems.length - 1].focus();
            break;
        }
      }

      var submenu = target.closest('.header__dropdown-menu, .mega-menu__linklist');
      if (submenu) {
        var links = Array.from(submenu.querySelectorAll('a'));
        var linkIdx = links.indexOf(target);

        if (linkIdx > -1) {
          switch (e.key) {
            case 'ArrowDown':
              e.preventDefault();
              links[Math.min(linkIdx + 1, links.length - 1)].focus();
              break;

            case 'ArrowUp':
              e.preventDefault();
              if (linkIdx === 0) {
                var parentDetails = submenu.closest('details');
                if (parentDetails) {
                  var summary = parentDetails.querySelector('summary');
                  if (summary) summary.focus();
                }
              } else {
                links[linkIdx - 1].focus();
              }
              break;

            case 'Home':
              e.preventDefault();
              links[0].focus();
              break;

            case 'End':
              e.preventDefault();
              links[links.length - 1].focus();
              break;

            case 'ArrowRight':
              var parentDetails = submenu.closest('details');
              if (parentDetails) {
                var summary = parentDetails.querySelector('summary');
                var parentIdx = topItems.indexOf(summary);
                if (parentIdx > -1) {
                  e.preventDefault();
                  parentDetails.open = false;
                  parentDetails.setAttribute('aria-expanded', 'false');
                  topItems[(parentIdx + 1) % topItems.length].focus();
                }
              }
              break;

            case 'ArrowLeft':
              var parentDetails = submenu.closest('details');
              if (parentDetails) {
                var summary = parentDetails.querySelector('summary');
                var parentIdx = topItems.indexOf(summary);
                if (parentIdx > -1) {
                  e.preventDefault();
                  parentDetails.open = false;
                  parentDetails.setAttribute('aria-expanded', 'false');
                  topItems[(parentIdx - 1 + topItems.length) % topItems.length].focus();
                }
              }
              break;
          }
        }
      }
    });
  }

  var mql = window.matchMedia('(min-width: 1000px)');

  function handleChange(e) {
    if (e.matches) init();
  }

  if (mql.matches) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  mql.addEventListener('change', handleChange);
})();
